<template>
    <div class="taxo-setup container-fluid">
        <CRow class="pr-2">
    <CCol col="10" xl="10" class="p-0">
      <CCard >
        <CCardBody>

   <a-card class="edit-card"  style="margin:0; padding:0;"  :body-style="{padding:0}">
                          <span slot="title">
                            <h6 class="w-100 mb-0 text-muted">Používatelia</h6>
                            Nastavenia</span>
                            <span slot="extra">
<template v-if="actualTab == 'fields'"><a-button type="primary" class=" mr-3" @click="openFieldModal">Pridať pole</a-button></template>
                           </span>

            <a-tabs v-model="actualTab" tab-position="left" class="mt-3">
  <a-tab-pane tab="Polia" key="fields">
    <div class="table-responsive p-3">
                            <table class="ant-table-body" style="font-size:14px;">
                                <tr>
                                    <th></th>
                                    <th>Názov poľa</th>
                                    <th>Typ poľa</th>
                                    <th>Slug</th>
                                    <th></th>
                                </tr>
                                <draggable @change="updateOrderFields" v-model="contenttype.fields" tag="tbody" class="ant-table-tbody" handle=".handle">
                                    <tr v-for="item in contenttype.fields" :key="item.id" class="ant-table-row ant-table-row-level-0">
                                        <td scope="row" style="width:30px;"> <a class="handle"><i class="fa fa-expand-arrows-alt"></i></a></td>
                                        <td>{{ item.title }}</td>
                                        <td>{{ types[item.type-1].label }}</td>
                                        <td>{{ item.slug }}</td>
                                        <td style="min-width:200px;text-align: right;">
                                            <a-button type="secondary"  @click="openFieldModal(item)" class="mr-2" title="Zmazať">Uprav</a-button>
                                            <a-popconfirm placement="topRight"
                                                          @confirm="confirm(item.id,item.weight)"
                                                          @cancel="cancel"
                                                          okText="Áno"
                                                          cancelText="Nie">
                                                <template slot="title">
                                                    <h5 color="danger" >Prajete si tento obsah vymazať?</h5>
                                                    Položka bude trvalo odstránená z vašej stránky.
                                                </template>
                                                <a-button type="secondary"  title="Zmazať">Zmazať</a-button>
                                            </a-popconfirm>
                                        </td>
                                    </tr>
                                </draggable></table>
                        </div>


  </a-tab-pane>

</a-tabs>
</a-card></CCardBody>
</CCard>
</CCol>

    <CCol col="2" xl="2" class="pl-0">
    <CCard class="p-0 pt-2 filter-side">
   <CCardBody>

          <a-card class="edit-card" style="margin:0; margin-top:10px" :body-style="{padding:0}">
      <div class="option-buttons">
      <router-link :to="'/users'"><a-button class="fs-12">Späť na zoznam</a-button></router-link>
    </div>
  </a-card>
  </CCardBody>
</CCard>
  </CCol>
</CRow>

                              <a-modal :title="parseInt(newField.id) ? 'Úprava poľa' : 'Nové pole'" centered  v-model="addFieldModal" v-if="addFieldModal" @ok="handleNewFieldSubmit">
                        <div class="additional-setup">
                            <div>
                                 <div class="row">
                                    <div class="col-md-12">
                                      <a-form-item label="Názov poľa" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-input placeholder="Názov poľa" v-model="newField.title"></a-input>
                                      </a-form-item>
                                    </div>
                                    <div class="col-md-12">
                                      <a-form-item label="Slug" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-input placeholder="Slug" v-model="newField.slug"></a-input>
                                      </a-form-item>
                                    </div>
                                    <div class="col-md-12" v-if="!parseInt(newField.id)">
                                      <a-form-item label="Typ poľa" :labelCol="labelCol" :wrapperCol="wrapperCol">
                                        <a-select defaultValue="1" v-model="newField.type" @change="handleChange" :options="types" class="w-100" style="min-height:40px;"/>
                                      </a-form-item>
                                    </div>

                                    <template v-if="(newField.type === '8' || newField.type === '22')">
                                        <div class="col-md-12">


       <a-form-item label="Typ obsahu" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-select  v-model="newField.content_type" class="w-100" style="min-height:40px;">
          <template v-for="k in contenttypes"><a-select-option :key="k.id" :value="k.id">{{k.title}}</a-select-option></template>
      </a-select>   </a-form-item>
      <a-form-item label="Polia" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-select mode="multiple" v-model="newField.fieldoptions" class="w-100" style="min-height:40px;">
          <template v-for="k in subfields"><a-select-option v-if="k.type != 20" :key="k.id" :value="k.slug">{{k.title}}</a-select-option></template>
      </a-select>

                                            </a-form-item>

                                        </div>
                                    </template>
                                    <template v-if="newField.type === '12' && !parseInt(newField.id)">
                                       <div class="col-md-12">

<a-form-item label="Slovníky taxonómie" :labelCol="labelCol" :wrapperCol="wrapperCol">
  <a-select  v-model="newField.content_type" class="w-100" style="min-height:40px;">
    <template v-for="k in taxonomies">
    <a-select-option :k="'cjae0' + k.id" :value="k.id">{{ k.title }}</a-select-option>
    </template>
  </a-select>
                                          </a-form-item>
                                        </div>
                                    </template>
                                    <div class="col-md-12 mt-1" v-if="newField.type === '17' && !parseInt(newField.id)">
  <a-form-item
                                                v-for="k in form.getFieldValue('keys')"
                                                :key="k"
                                                :labelCol="labelCol" :wrapperCol="wrapperCol"
                                                v-bind="formItemLayout"
                                                :required="false"

                                        >
                                            <a-input  v-model="newField.fieldcolection.title[k]" class="w-100" placeholder="Názov"/>
                                            <a-select defaultValue="1" :options="types" class="w-100"  v-model="newField.fieldcolection.type[k]" placeholder="Typ poľa"/>
<div v-if="newField.fieldcolection.type[k] === '12'">
<a-select defaultValue="1" :options="taxs" v-model="newField.fieldcolection.setup[k]" class="w-100"  placeholder="Vyberte slovník taxonómie"></a-select>
</div>
                                            <a-icon
                                                    v-if="form.getFieldValue('keys').length > 1"
                                                    class="dynamic-delete-button"
                                                    type="minus-circle-o"
                                                    :disabled="form.getFieldValue('keys').length === 1"
                                                    @click="() => remove(k)"
                                            />
                                        </a-form-item>
                                        <a-form-item>
                                            <a-button type="dashed" style="width: 60%; float:left" @click="add">
                                                <a-icon type="plus" /> Pridaj pole
                                            </a-button>
                                        </a-form-item>
                                    </div>
                                    <div class="col-md-12" v-if="newField.type === '2' && !parseInt(newField.id)">
                                        <a-form-item
                                                v-for="k in form.getFieldValue('keys')"
                                                :key="k"
                                                v-bind="formItemLayout"
                                                style="margin-top:10px;"
                                                :required="false"

                                        >
                                            <a-input style="float:left;width:45%; margin-right:2%;" v-model="newField.options[k].title" placeholder="Názov"/>
                                            <a-input style="float:left;width:45%;" v-model="newField.options[k].slug" placeholder="Slug"/>

                                            <a-icon
                                                    v-if="form.getFieldValue('keys').length > 1"
                                                    class="dynamic-delete-button"
                                                    style="position:relative;left:10px;top:-3px;"
                                                    type="minus-circle-o"
                                                    :disabled="form.getFieldValue('keys').length === 1"
                                                    @click="() => remove(k)"
                                            />
                                        </a-form-item>
                                        <a-form-item >
                                            <a-button type="primary" style="margin-top:20px;text-align:left;" @click="add"> + Pridať</a-button>
                                        </a-form-item>
                                    </div>
                                </div>
                                <a-form-item label="Multirozmerné pole" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.multibool"></a-checkbox>
                              </a-form-item>
                              <a-form-item label="Samostatne preložiteľné pole" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.translatablebool" ></a-checkbox>
                              </a-form-item>
                                <a-form-item label="Jazykovo nezávislá položka" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.independentbool" ></a-checkbox>
                              </a-form-item>
                                <a-form-item label="Filtrovateľná položka" :labelCol="labelCol" :wrapperCol="wrapperCol" class="mb-0">
                                <a-checkbox v-model="newField.filterablebool"></a-checkbox>
                              </a-form-item>
                            </div>
                        </div>
                    </a-modal>

</CRow>
</div>
</template>
<script>
    import {API_URL} from "../api";
    import {authHeader} from "../_helpers";
    import {dataService} from "../_services";
    import Vue from "vue"
    import Image from "./content/Image";
    import FormItem from 'ant-design-vue'
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import {Popconfirm} from "ant-design-vue"
    import draggable from "vuedraggable";

    Vue.use(FormItem);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'title',
            sorter: true,
            width: '20%',
        },
        {
            title: 'Typ poľa',
            dataIndex: 'type',
            scopedSlots: {customRender: 'cttype'},
        },
        {
            title: 'Slug',
            dataIndex: 'slug',
        },
        {
            align: 'right',
            scopedSlots: {customRender: 'name'},
        }
    ];
    let id = 0;
    export default {
        name: 'taxonomy',
        components: {AFormItem, "a-popconfirm": Popconfirm,draggable,'image-upload' : Image},
        props: ['id'],

        data() {
            return {
                data: [],
                colorsto: JSON.parse(localStorage.colors),
                newField: {
                    title : null,
                    type : null,
                    fieldcolection: {'title':[],'type':[]},
                    multi: false,
                    multibool: false,
                    independentbool: false,
                    translatablebool: false,
                    options : [],
                    slug : null,
                    content_id : this.id
                },
                loading: false,
                 labelCol: { span: 10 },
                wrapperCol: { span: 14 },
                labelCol2: { span: 6 },
                wrapperCol2: { span: 18 },
                subfields:{},
                addFieldModal:false,
                actualTab: 'fields',
                columns,
                types: [
                    {"value" : '1' ,"label" : 'Text'},
                    {"value" : '2' ,"label" : 'Výberovník'},
                    {"value" : '3' ,"label" : 'Obrázok'},
                    {"value" : '4' ,"label" : 'Dlhý text'},
                    {"value" : '5' ,"label" : 'Celé číslo'},
                    {"value" : '6' ,"label" : 'Desatiné číslo'},
                    {"value" : '7' ,"label" : 'Logická hodnota Áno/Nie'},
                    {"value" : '8' ,"label" : 'Priradenie pod typ obsahu'},
                    {"value" : '9' ,"label" : 'Dynamická hodnota'},
                    {"value" : '10' ,"label" : 'Builder'},
                    {"value" : '11' ,"label" : 'Galéria obrázkov'},
                    {"value" : '12' ,"label" : 'Priradenie pod taxonómiu'},
                    {"value" : '13' ,"label" : 'Priradenie pod taxonómiu s násobkom'},
                    {"value" : '14' ,"label" : 'Dátum'},
                    {"value" : '15' ,"label" : 'Multipole - vlastnosti'},
                    {"value" : '16' ,"label" : 'Dátum od - do'},
                    {"value" : '17' ,"label" : 'Multipole'},
                    {"value" : '18' ,"label" : 'Ikona'},
                    {"value" : '19' ,"label" : 'Súbor'},
                    {"value" : '20' ,"label" : 'Farba'},
                ],
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 4 },
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 20 },
                    },
                },
                formItemLayoutWithOutLabel: {
                    wrapperCol: {
                        xs: { span: 24, offset: 0 },
                        sm: { span: 20, offset: 4 },
                    },
                },
                head: authHeader(),
                send: API_URL,
                contenttypes: [],
                productCat: {},
                contenttypeId: {
                    uid: this.id
                },
                contenttype: {
                    title: '',
                    type: '',
                },
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this, { name: 'dynamic_form_item' });
            this.form.getFieldDecorator('keys', { initialValue: [], preserve: true });
        },
        methods: {
            openFieldModal(idd = false){
                if(parseInt(idd.id) > 0)
                {
                    this.newField = idd;
                }
                else {
                    this.newField = {title : null,type : null, blocks: [],options : [], fieldcolection: {'title':[],'type':[]}, multi: false, slug : null,content_id : this.id };
                }
                this.addFieldModal = true;
            },
            confirm(e) {
                dataService.axiosDelete("taxonomyfields", e).then(results => {
                    if (results) {
                        this.contenttype.fields.splice(this.data.findIndex(x => parseInt(x.id) === parseInt(e)), 1);
                    }
                });
            },
            cancel() {
            },
            handleChange(value) {
                console.log(`selected ${value}`);
            },
            remove(k) {
                const { form } = this;
                // can use data-binding to get
                const keys = form.getFieldValue('keys');
                // We need at least one passenger
                if (keys.length === 1) {
                    return;
                }

                // can use data-binding to set
                form.setFieldsValue({
                    keys: keys.filter(key => key !== k),
                });
            },

            add() {
                const { form } = this;
                // can use data-binding to get
                const keys = form.getFieldValue('keys');
                const nextKeys = keys.concat(id++);
                // can use data-binding to set
                // important! notify form to detect changes
                form.setFieldsValue({
                    keys: nextKeys,
                });
            },
            onChildChange (value,slug) {
                console.log(value);
                this.contenttype.image = JSON.stringify(value); // someValue
            },
            handleSubmit() {
                let $contenttype_data = this.contenttype;
                dataService.axiosPost(this.$options.name, $contenttype_data).then(results => {

                    if(results.data.message)
                    {this.contenttype = []; }

                });
            },
            onChange(checked) {
                this.newField.multi = checked;
            },
            updateOrderFields()
            {

                console.log(this.contenttype.fields);
                dataService.axiosPost('reorderfields/' + this.id, this.contenttype.fields).then(results => {

                });
            },
             saveReorder()
            {
                dataService.axiosPost('reorderblockstax/' + this.id, this.contenttype.blocks).then(results => {

                });
            },
            handleNewFieldSubmit()
            {  this.addFieldModal = false;

                this.newField.multi = this.newField.multibool;
                this.newField.independent = this.newField.independentbool;
                this.newField.translatable = this.newField.translatablebool;
                let $contenttype_data = this.newField;
                dataService.axiosPost("newuserfield", $contenttype_data).then(results => {
                    if(results.data.data)
                    {
                        this.contenttype.fields = results.data.data.fields;
                    }
                });
            },
        },
        mounted() {

                dataService.axiosFetch('userfields').then(results => {
                    this.contenttype = results;
                });


            dataService.axiosFetch('taxonomies').then(results => {
                this.taxonomies = results;
                this.loading = false;
            });

            dataService.axiosFetch('taxonomyitems',"product_category").then(results => {

                var roleops = [];
                roleops.push({"value" : '0' , "label" : 'Nie je produkt'});
                results.forEach(obj => { roleops.push({"value" : obj.id , "label" : obj.title}); });

                this.productCat = roleops;
                this.loading = false;
            });



            dataService.axiosFetch("contenttypes").then(results => {
                this.contenttypes = results;
                this.loading = false;
            });


        }
    };
</script>

<style scoped>
.option-card
{position:fixed; right:25px}
.option-buttons
    {margin-top:15px;}
    .option-buttons button
    {
      margin:0 auto;
      display:block;
      margin-bottom:10px;
      width:90%;
    }
    .input-group .input-group-prepend .input-group-text {
        border: 0;
    }
    .dynamic-delete-button {
        cursor: pointer;
        position: relative;
        top: 4px;
        font-size: 24px;
        color: #999;
        transition: all 0.3s;
    }
    .dynamic-delete-button:hover {
        color: #777;
    }
    .dynamic-delete-button[disabled] {
        cursor: not-allowed;
        opacity: 0.5;
    }
    .element
    {display:block;width:100%; border-top-left-radius: 5px;border-top-right-radius:5px;overflow:hidden;}
.taxo-setup .ant-table-body
{width:100%;}
    .element
    {
        padding:0;
        border-bottom:1px solid #fff;
        border-radius:0;
    }
    .manager
    {width:800px}
    .top-holder
    {width:100%;border:1px solid #eceff3; padding:15px   }
    .element-image
    {width:100%; border-bottom:1px solid #eceff3; padding-bottom:10px;margin-bottom:10px;}

    .element .handle
    {font-size:22px;padding:5px}
    .element span
    {width:100%; display:block;color: #33a6ba;  text-align:left; min-height:30px; padding-left:5px; font-size:14px; background-color: #a3e4ff;}
    .edit-button
    {float:right; margin:0; margin-left:2px;border-radius:0px; background-color: rgba(0, 0, 0, 0.04); border: 0; color:#fff;
    }
    .ant-select-selection--single
    {width:100%;
        height: calc(1.5em + 1.25rem + 2px);
        padding: 0.625rem 0.75rem;}

</style>
